<template>
  <svg
    width="145"
    height="145"
    viewBox="0 0 145 145"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="[&_path]:fill-green-50"
  >
    <g clip-path="url(#clip0_1836_2763)">
      <path
        d="M30.7634 90.9338L32.8142 94.9459L35.4277 94.6726L36.2597 96.2937L25.535 97.278L24.5816 95.4266L31.6427 87.2969L32.5148 88.9873L30.7634 90.9338ZM31.2681 95.088L29.7303 92.0845L26.6435 95.5179L26.6635 95.5526L31.2631 95.0794L31.2681 95.088Z"
      />
      <path
        d="M26.392 84.1623L28.1367 85.1642L30.9492 84.4757L31.3939 86.2859L21.675 88.6523L21.2304 86.8421L26.1183 85.6482L20.1362 82.347L19.6358 80.2803L24.8376 83.27L29.2649 77.5384L29.7943 79.7154L26.392 84.1623Z"
      />
      <path
        d="M20.7121 73.8046L20.7565 77.3816L19.288 77.398L19.1809 68.3724L20.6494 68.3559L20.6952 71.9553L29.2147 71.8516L29.2403 73.6959L20.7207 73.7996L20.7121 73.8046Z"
      />
      <path
        d="M30.4226 62.8635C29.8364 65.4882 28.0594 66.7105 25.3664 66.106L19.5719 64.8096L19.9781 62.9931L25.7863 64.2932C27.4934 64.6701 28.6246 64.1094 28.9786 62.5425C29.3326 60.9756 28.5553 59.9694 26.8432 59.5838L21.035 58.2837L21.4375 56.4809L27.2594 57.7847C29.9251 58.3818 31.0174 60.2338 30.4226 62.8635Z"
      />
      <path
        d="M31.8846 56.9157L22.8519 52.6506L25.9164 46.1586L27.2489 46.7864L24.9547 51.6328L27.468 52.826L29.4955 48.5377L30.828 49.1656L28.8005 53.4539L31.3275 54.6508L33.6413 49.7584L34.9738 50.3863L31.8809 56.9293L31.8846 56.9157Z"
      />
      <path
        d="M27.9336 42.8924L29.0495 41.4052L35.8584 46.5385L38.967 42.4228L40.1356 43.3069L35.9111 48.9098L27.9286 42.8837L27.9336 42.8924Z"
      />
      <path
        d="M36.6055 34.9527L33.9694 37.3869L32.9773 36.3084L39.617 30.1887L40.6091 31.2671L37.9644 33.7063L43.7438 39.9766L42.385 41.223L36.6055 34.9527Z"
      />
      <path
        d="M55.5358 25.7207C56.654 25.3176 57.8809 25.9026 58.269 26.9948C58.6722 28.1131 58.1009 29.3436 56.9826 29.7467C55.8644 30.1498 54.6202 29.5749 54.2171 28.4567C53.8289 27.3644 54.4175 26.1239 55.5358 25.7207Z"
      />
      <path
        d="M77.1557 26.9678L72.6545 26.6914L71.5612 29.0778L69.7448 28.9717L74.3578 19.2417L76.4397 19.3676L79.8441 29.5842L77.9421 29.4698L77.1557 26.9678ZM73.3143 25.2943L76.6778 25.5001L75.2889 21.0943L75.2442 21.097L73.3057 25.2993L73.3143 25.2943Z"
      />
      <path
        d="M85.2055 26.6504L83.4648 27.6554L82.6225 30.4164L80.8426 29.8737L83.7359 20.305L85.5158 20.8478L84.0575 25.662L89.9374 22.1863L91.9768 22.7987L86.7693 25.759L89.4623 32.4834L87.3223 31.8368L85.2191 26.654L85.2055 26.6504Z"
      />
      <path
        d="M96.9918 27.0047L93.8793 25.2337L94.6092 23.9579L102.453 28.4242L101.723 29.7001L98.5922 27.9167L94.3683 35.3206L92.7679 34.4086L96.9918 27.0047Z"
      />
      <path
        d="M101.505 40.9226C99.5448 39.0869 99.3975 36.9318 101.284 34.919L105.343 30.5894L106.701 31.8609L102.633 36.1955C101.442 37.4722 101.352 38.7365 102.52 39.8402C103.697 40.9389 104.955 40.7782 106.152 39.5102L110.214 35.167L111.567 36.4298L107.487 40.7831C105.622 42.7722 103.476 42.7756 101.497 40.9276L101.505 40.9226Z"
      />
      <path
        d="M105.879 45.1985L114.159 39.5986L118.18 45.5443L116.957 46.3659L113.953 41.9227L111.646 43.4859L114.305 47.4122L113.082 48.2338L110.422 44.3075L108.106 45.8757L111.135 50.3623L109.912 51.1839L105.861 45.1861L105.879 45.1985Z"
      />
      <path
        d="M119.955 48.9189L120.673 50.641L112.786 53.9011L114.761 58.6615L113.401 59.2269L110.718 52.7394L119.964 48.9139L119.955 48.9189Z"
      />
      <path
        d="M122.415 60.4197L121.663 56.9165L123.101 56.6063L125.01 65.4341L123.573 65.7444L122.81 62.2239L114.473 64.0236L114.087 62.2144L122.424 60.4147L122.415 60.4197Z"
      />
      <path
        d="M120.746 81.4289C120.521 82.5983 119.397 83.3513 118.255 83.1331C117.085 82.9076 116.315 81.7935 116.541 80.624C116.766 79.4546 117.897 78.6744 119.062 78.8912C120.204 79.1094 120.967 80.2508 120.75 81.4153L120.746 81.4289Z"
      />
      <path
        d="M108.708 99.4181L111.226 95.6784L109.725 93.5194L110.737 92.0116L116.796 100.926L115.636 102.658L105.095 100.419L106.155 98.8366L108.713 99.4268L108.708 99.4181ZM112.099 96.9521L110.22 99.7574L114.723 100.795L114.747 100.758L112.104 96.9607L112.099 96.9521Z"
      />
      <path
        d="M104.891 106.506L104.923 104.502L102.962 102.366L104.334 101.101L111.096 108.455L109.725 109.72L106.323 106.026L106.325 112.849L104.753 114.288L104.856 108.305L97.7062 107.202L99.3491 105.688L104.882 106.511L104.891 106.506Z"
      />
      <path
        d="M98.4732 116.551L101.604 114.813L102.321 116.096L94.4347 120.476L93.717 119.193L96.8647 117.445L92.726 109.996L94.3431 109.097L98.4819 116.546L98.4732 116.551Z"
      />
      <path
        d="M84.3051 113.311C86.8804 112.551 88.8196 113.51 89.5967 116.156L91.278 121.848L89.4904 122.372L87.8042 116.672C87.3093 114.994 86.263 114.282 84.722 114.733C83.1723 115.189 82.6826 116.361 83.1689 118.043L84.8551 123.744L83.0813 124.271L81.3937 118.548C80.623 115.933 81.7074 114.072 84.3051 113.311Z"
      />
      <path
        d="M78.402 114.906L79.0368 124.886L71.8733 125.338L71.7762 123.87L77.1231 123.531L76.947 120.746L72.2114 121.044L72.1143 119.576L76.8499 119.278L76.6774 116.479L71.2722 116.817L71.1751 115.349L78.397 114.898L78.402 114.906Z"
      />
      <path
        d="M68.0396 125.138L66.1915 124.877L67.3918 116.436L62.2944 115.707L62.5025 114.248L69.4479 115.238L68.0396 125.138Z"
      />
      <path
        d="M56.9243 121.406L60.3254 122.537L59.8628 123.935L51.2966 121.098L51.7593 119.7L55.1741 120.834L57.8557 112.739L59.6109 113.319L56.9293 121.414L56.9243 121.406Z"
      />
      <path
        d="M39.6119 109.3C38.7178 108.511 38.6411 107.159 39.4087 106.288C40.1973 105.394 41.5489 105.295 42.443 106.084C43.3371 106.872 43.4325 108.237 42.6489 109.14C41.8812 110.011 40.506 110.089 39.6169 109.309L39.6119 109.3Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_1836_2763">
        <rect
          width="106.1"
          height="105.76"
          fill="white"
          transform="translate(0 53.05) rotate(-30)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
